"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStartLogs = exports.startLogs = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logsSessionManager_1 = require("../domain/logsSessionManager");
var assemble_1 = require("../domain/assemble");
var consoleCollection_1 = require("../domain/logsCollection/console/consoleCollection");
var reportCollection_1 = require("../domain/logsCollection/report/reportCollection");
var networkErrorCollection_1 = require("../domain/logsCollection/networkError/networkErrorCollection");
var runtimeErrorCollection_1 = require("../domain/logsCollection/runtimeError/runtimeErrorCollection");
function startLogs(configuration, sender) {
    var internalMonitoring = startLogsInternalMonitoring(configuration);
    internalMonitoring.setExternalContextProvider(function () {
        var _a;
        return (0, browser_core_1.combine)({ session_id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id }, (0, assemble_1.getRUMInternalContext)(), {
            view: { name: null, url: null, referrer: null },
        });
    });
    internalMonitoring.setTelemetryContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = (0, assemble_1.getRUMInternalContext)()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = (0, assemble_1.getRUMInternalContext)()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = (0, assemble_1.getRUMInternalContext)()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    (0, networkErrorCollection_1.startNetworkErrorCollection)(configuration, sender);
    (0, runtimeErrorCollection_1.startRuntimeErrorCollection)(configuration, sender);
    (0, consoleCollection_1.startConsoleCollection)(configuration, sender);
    (0, reportCollection_1.startReportCollection)(configuration, sender);
    var session = (0, browser_core_1.areCookiesAuthorized)(configuration.cookieOptions) && !(0, browser_core_1.canUseEventBridge)()
        ? (0, logsSessionManager_1.startLogsSessionManager)(configuration)
        : (0, logsSessionManager_1.startLogsSessionManagerStub)(configuration);
    return doStartLogs(configuration, session, sender);
}
exports.startLogs = startLogs;
function startLogsInternalMonitoring(configuration) {
    var _a, _b;
    var internalMonitoring = (0, browser_core_1.startInternalMonitoring)(configuration);
    if ((0, browser_core_1.canUseEventBridge)()) {
        var bridge_1 = (0, browser_core_1.getEventBridge)();
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return bridge_1.send('internal_log', message); });
        internalMonitoring.telemetryEventObservable.subscribe(function (message) { return bridge_1.send('internal_telemetry', message); });
    }
    else {
        if (configuration.internalMonitoringEndpointBuilder) {
            var batch_1 = (0, browser_core_1.startBatchWithReplica)(configuration, configuration.internalMonitoringEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.internalMonitoringEndpointBuilder);
            internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return batch_1.add(message); });
        }
        var monitoringBatch_1 = (0, browser_core_1.startBatchWithReplica)(configuration, configuration.rumEndpointBuilder, (_b = configuration.replica) === null || _b === void 0 ? void 0 : _b.rumEndpointBuilder);
        internalMonitoring.telemetryEventObservable.subscribe(function (event) { return monitoringBatch_1.add(event); });
    }
    return internalMonitoring;
}
function doStartLogs(configuration, sessionManager, sender) {
    var _a;
    var assemble = (0, assemble_1.buildAssemble)(sessionManager, configuration, sender);
    var onLogEventCollected;
    if ((0, browser_core_1.canUseEventBridge)()) {
        var bridge_2 = (0, browser_core_1.getEventBridge)();
        onLogEventCollected = function (message) { return bridge_2.send('log', message); };
    }
    else {
        var batch_2 = (0, browser_core_1.startBatchWithReplica)(configuration, configuration.logsEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.logsEndpointBuilder);
        onLogEventCollected = function (message) { return batch_2.add(message); };
    }
    return {
        send: function (message, currentContext) {
            var contextualizedMessage = assemble(message, currentContext);
            if (contextualizedMessage) {
                onLogEventCollected(contextualizedMessage);
            }
        },
    };
}
exports.doStartLogs = doStartLogs;
//# sourceMappingURL=startLogs.js.map